import { useReducer as u } from "react";
function n(r, e) {
  switch (e.type) {
    case "RESOLVE":
      return { value: e.value, error: void 0 };
    case "REJECT":
      return { value: !1, error: e.error };
    case "RESET":
      return { value: void 0, error: void 0 };
    default:
      return r;
  }
}
function f() {
  return u(n, { value: void 0, error: void 0 });
}
export {
  f as default
};
//# sourceMappingURL=useResolver.es.js.map
